/**
 * Many APIs wrap payloads as `{ data: { ...fields } }`. Merge so consumers see fields at top level.
 * Does not merge when `data` is an array (e.g. list endpoints).
 */
export function flattenApiBody(body) {
  if (body == null || typeof body !== "object") return body || {};
  const inner = body.data;
  if (
    inner &&
    typeof inner === "object" &&
    !Array.isArray(inner) &&
    Object.keys(inner).length > 0
  ) {
    const { data: _nested, ...rest } = body;
    return { ...rest, ...inner };
  }
  return { ...body };
}
